(() => {
  const initialize = root => {
    const controls = [...(root.matches?.('.miez-wishlist-button') ? [root] : []), ...root.querySelectorAll('.miez-wishlist-button')];
    controls.forEach(control => {
      if (!control.querySelector('button')) document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: control }));
      const button = control.querySelector('button');
      if (button && !button.getAttribute('aria-label')) button.setAttribute('aria-label', control.dataset.miezWishlistLabel);
    });
  };
  document.addEventListener('wishlist-hero-wishlist-sdk-ready', () => initialize(document));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('button') && node.closest('.miez-wishlist-button')) {
        if (!node.getAttribute('aria-label')) node.setAttribute('aria-label', node.closest('.miez-wishlist-button').dataset.miezWishlistLabel);
      } else if (node.matches('.miez-wishlist-button') || node.querySelector('.miez-wishlist-button')) initialize(node);
    }));
  }).observe(document.body, { childList:true, subtree:true });
  initialize(document);
})();
